import { styled } from '@mui/system';
import {
  Box,
  Button,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';

export const Wrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  flex: 1,
  gridArea: 'filter',
  [theme.breakpoints.down('md')]: {
    flex: '1'
  }
}));

export const FilterContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '75%',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));

export const FilterBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 8,
  left: 0,
  width: '100%',
  backgroundColor: '#FFF',
  borderRadius: 8,
  boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
  padding: '24px 32px',
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  [theme.breakpoints.up('sm')]: {
    minWidth: '512px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '12px 8px',
    gap: 16,
    minWidth: '100%'
  }
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  margin: 0,
  [theme.breakpoints.up('sm')]: {
    margin: 0
  },
  '& button:nth-of-type(2)': {
    marginRight: 0
  }
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1)
}));

// Mobile styles
export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  position: 'relative'
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(3),
  top: '30px'
}));

export const FilterTitle = styled(Typography)(() => ({
  padding: '20px 0'
}));

export const FilterOptionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 12,
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'space-between'
  }
}));
